module.exports = __webpack_public_path__ + "img/product10.125226f4.png";